import {CLINICDATA} from '../constants'
import axiosInstance from "../utils/axios.interceptor";

const loadallclinicdata = () =>{
  return new Promise(async (resolve, reject) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/loadexportableclinicdata',
      data: {}
    });
    resolve(response.data);
  });
}

const loadclinicdata = (clinicname) =>{
  return new Promise(async (resolve, reject) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/loadclinicdata',
      data: {"clinicname": clinicname}
    });
    resolve(Object.values(response.data));
  });
}

const readfilenames = (clinicname) =>{
  return new Promise(async (resolve, reject) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/readfilenames',
      data: {"foldername": clinicname}
    });
    resolve(Object.values(response.data));
  });
}

const readsupportingfiles = (foldername) =>{
  return new Promise(async (resolve, reject) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/readsupportingfiles',
      data: { "foldername":foldername}
    });
    resolve(Object.values(response.data));
  });
}

export const listClinicData = (clinicname) => {
  return async (dispatch) => {
    let newBuffer = [];
    let [clinicdata, filenames, supportingfiles] = await Promise.all([
      loadclinicdata(clinicname),
      readfilenames(clinicname),
      readsupportingfiles(clinicname)
    ]);
    let responseObj = {};
    responseObj.filenames = filenames;
    responseObj.supportingfiles = supportingfiles;
    clinicdata.map(((item,index)=>{
      let filename = ""; let filepath = "";
      filenames.map(fileitem=>{
      if(fileitem.filename.replace(".pdf","") == item.IPNo){filename = fileitem.filename ; filepath = fileitem.filepath; }
      });
      item.filename = filename;
      item.filepath = filepath;
      item.id = index;

      //Check if supporting files exist or else do not display.
      let supportingFileExists = false;
      supportingfiles.map((supportingfile)=>{ if(supportingfile.filename.split("-")[0] + ".pdf"==filename){supportingFileExists = true;}});

      if(item.filename.toString().length>1 && supportingFileExists){newBuffer.push(item);}
    }));
    responseObj.clinicdata = newBuffer;
    newBuffer.timestamp = new Date().toLocaleString();
    dispatch({type:CLINICDATA,payload:responseObj});
  };
};

export const readtablesforpcl = () => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'GET',
      url: '/readtablesforpcl',
      data: {}
    });
    dispatch({type:CLINICDATA,payload:Object.values(response.data)});
  }
}
